import getOffsetRect from "./getOffsetRect.js";
import ValidatingInput from "./ValidatingInput.js";

export default function Header() {
    const headerSticky = document.getElementById("header-sticky");
    const headerStickyOffsetTop = getOffsetRect(headerSticky).top;
    const headerStickyWrapper = headerSticky.querySelectorAll("div")[0];
    const headerMenuOpenButtonElement = document.getElementById("header-menu-open-button");
    const headerMenuTopNavElement = document.getElementById("header-top-nav");
    const headerMenuTopNavBaseClass = headerMenuTopNavElement.getAttribute("data-base-class");
    let isTopNavOpened = false;

    const headerSearchElement = document.querySelector(".js-header-search");
    const headerSearchOpenButton = headerSearchElement.querySelector(".js-header-search-open-button");
    let isHeaderSearchActive = false;
    const headerSearchForm = headerSearchElement.querySelector(".js-header-search-form");
    headerSearchForm.setAttribute("novalidate", true);
    const headerSearchInput = headerSearchForm.querySelector(".js-header-search-input");
    const headerSearchInputObject = new ValidatingInput({
        "domElement": headerSearchInput,
        "requiredFlag": true,
        "errorClass": "is-invalid"
    });

    window.addEventListener("load", checkPosition);

    window.addEventListener("scroll", function() {
        checkPosition();
    });

    headerMenuOpenButtonElement.addEventListener("click", function() {
        if (!isTopNavOpened) {
            isTopNavOpened = true;
            this.classList.add("is-active");
            headerMenuTopNavElement.classList.add(headerMenuTopNavBaseClass + "_revealing");
            headerMenuTopNavElement.classList.remove(headerMenuTopNavBaseClass + "_static");
        } else {
            isTopNavOpened = false;
            this.classList.remove("is-active");
            headerMenuTopNavElement.classList.add(headerMenuTopNavBaseClass + "_static");
            headerMenuTopNavElement.classList.remove(headerMenuTopNavBaseClass + "_revealing");
        }
    });

    headerSearchOpenButton.addEventListener("click", function() {
        if (!isHeaderSearchActive) {
            headerSearchElement.classList.add("is-active");
            headerSearchInput.focus();
            isHeaderSearchActive = true;
        } else {
            headerSearchElement.classList.remove("is-active");
            isHeaderSearchActive = false;
        }
    });

    headerSearchForm.addEventListener("submit", function(e) {
        const isValid = validate();

        if (!isValid) {
            e.preventDefault();
        }
    });


    function checkPosition() {
        if (document.documentElement.scrollTop > headerStickyOffsetTop) {
            headerStickyWrapper.classList.add("is-fixed");
        } else {
            headerStickyWrapper.classList.remove("is-fixed");

            if (isTopNavOpened) {
                isTopNavOpened = false;
                headerMenuOpenButtonElement.classList.remove("is-active");
                headerMenuTopNavElement.classList.add(headerMenuTopNavBaseClass + "_static");
                headerMenuTopNavElement.classList.remove(headerMenuTopNavBaseClass + "_revealing");
            }
        }
    }

    function validate() {
        let isValid = true;

        const isInputValid = headerSearchInputObject.validate();

        if (!isInputValid) {
            isValid = false;
        }

        if (!isValid) {
            headerSearchForm.classList.add("not-valid");
        } else {
            headerSearchForm.classList.remove("not-valid");
        }

        return isValid;
    }
}